var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"send-btn-c",attrs:{"disabled":_vm.disable,"loading":_vm.load,"type":"danger"},on:{"click":_vm.send}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }